import React, {useEffect, useState} from 'react';
import './css/profilePage.css';
import Header from "../components/Header";
import Footer from "../components/Footer";
import connect from "react-redux/es/connect/connect";
import PropTypes from "prop-types";
import NoVideos from "../components/NoVideos";
import VideosContainer from "../components/VideosContainer";
import {getVideos, removeVideoRequest, setError, uploadVideo} from "../reducers/videos/actions";
import Loader from "react-loader-spinner";

function VideoPage({videos, isFetching, isError, loadVideos, removeVideoById, uploadVideo, clearError}) {
    const [isMounted, setMounted] = useState(false);

    useEffect(() => {
        if (!isMounted) {
            loadVideos();
            setMounted(true);
            document.title = videos.length === 0 ? 'Faces - Upload your first video ': 'Faces - Your uploaded videos'
        }
            if ( isError) {
                clearError();
                alert('Something went wrong =(');
            }
    });

    return (
        <div className="page">
            <div className="content">
                <Header videos={videos} isFetching={isFetching}/>
                <div className={`mobile ${videos.length===0? 'without-video': 'with-video'}`}/>
                {isFetching && <div style={{width: '100%', textAlign: 'center'}}>
                    <Loader
                        type="Plane"
                        color="#f4ff02"
                        width="100"
                        height="100"
                    />
                </div> }
                {!isFetching && (videos.length === 0 ? <NoVideos uploadVideo={uploadVideo}/> : <VideosContainer removeVideoById={removeVideoById} videos={videos}/>)}
                 <Footer/>
            </div>
        </div>
    );
}

VideoPage.propTypes = {
    videos: PropTypes.array,
    isFetching: PropTypes.bool,
    isError: PropTypes.any,
    loadVideos: PropTypes.func,
    uploadVideo: PropTypes.func,
    removeVideoById: PropTypes.func,
    clearError: PropTypes.func,
};

export default connect(state => {
        return {
            ...state.videos
        };
    },
    dispatch => {
        return {
            clearError: () => dispatch(setError(false)),
            loadVideos: () => dispatch(getVideos()),
            removeVideoById: (payload) => dispatch(removeVideoRequest(payload)),
            uploadVideo: (video) => dispatch(uploadVideo({video}))
        };
    })(VideoPage);
